import { render } from "./IdentityView.vue?vue&type=template&id=4c44b977&scoped=true"
const script = {}

import "./IdentityView.vue?vue&type=style&index=0&id=4c44b977&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c44b977"]])

export default __exports__